// AUTO-MANAGED: overwritten by scripts/set-build-mode.sh before npm publish.
// "development" allows --dev flag; "production" strips it.
export const BUILD_MODE: "development" | "production" = "production";
